module.exports = __webpack_public_path__ + "img/pause.fe1e23c5.svg";